/**
 * Staff — the store seam the session reconciler (@momo/session) does not
 * cover: the staff notice's acknowledgment, read and recorded under Revia's
 * organization. notice.sync.ts is the only caller.
 */
import { REVIA_ORG_ID, StaffNoticeAcknowledgment } from "@revia/types";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase.ts";

/** Whether this staff member has acknowledged this version of the staff
 *  notice: their own version record, empty until they do. */
export async function noticeAcknowledged(uid: string, version: string): Promise<boolean> {
	const snap = await getDoc(
		doc(db, "workspaces", REVIA_ORG_ID, "staffNotices", uid, "versions", version),
	);
	if (!snap.exists()) return false;
	StaffNoticeAcknowledgment.StaffNoticeAcknowledgmentSchema.parse(snap.data());
	return true;
}

export async function acknowledgeNotice(uid: string, version: string): Promise<void> {
	const record: Pick<StaffNoticeAcknowledgment.StaffNoticeAcknowledgment, "noticeVersion"> = {
		noticeVersion: version,
	};
	// acknowledgedAt is the server's clock, which the rule requires.
	await setDoc(doc(db, "workspaces", REVIA_ORG_ID, "staffNotices", uid, "versions", version), {
		...record,
		acknowledgedAt: serverTimestamp(),
	});
}
